import { BarcodeOrderListFilters } from "@/models/api/barcodeSystem/barcodeOrders/get";
import { BarcodeOrderResource } from "@/models/api/barcodeSystem/barcodeOrders/get";
import { CompanyResource } from "../../../../models/api/barcodeSystem/barcodeCompanies/get";

export function defaultBarcodeOrderFilters(): BarcodeOrderListFilters {
  return {
    id: null,
    loadId: null,
    orderNumber: null,
    crn: null,
    statuses: null,
    deliveryTypes: null,
    facilityCodes: null,
    actualFacilityCodes: null,
    billToCompanyIds: null,
    companyIds: null,
    customer: null,
    orderGroupText: null,
    orderGroupText2: null,
    relatedOrdersCRN: null,
    esnIdentity: null,
    noScanWithItems: null,
    isOpen: null,
    requiresReceiving: null,
    requiresPicking: null,
    requiresDelivery: null,
    isPuc: null,
    isPud: null,
    isLinkingComplete: null,
    isPrescheduled: null,
    importedDate: null,
    receivedDate: null,
    loadedDate: null,
    deliveredDate: null,
    receivingProcessedDate : null,
    loadingProcessedDate: null,
    deliveryProcessedDate: null,
    earliestAppt: null,
    latestAppt: null,
    originalEarliestAppt: null,
    originalLatestAppt: null,
    receivingUsername: null,
    loadingUsername: null,
    deliveryUsername: null
    } as BarcodeOrderListFilters;
}

export function defaultBarcodeOrder(): BarcodeOrderResource {
  return {
    id: null,
    loadId: null,
    orderNumber: null,
    crn: null,
    status: null,
    deliveryType: null,
    facilityCode: null,
    actualFacilityCode: null,
    billToCompanyId: null,
    company: null,
    customer: null,
    orderGroupText: null,
    orderGroupText2: null,
    relatedOrdersCRN: null,
    esnIdentity: null,
    noScanWithItems: null,
    isOpen: null,
    requiresReceiving: null,
    requiresPicking: null,
    requiresDelivery: null,
    isPuc: null,
    isPud: null,
    isLinkingComplete: null,
    isPrescheduled: null,
    importedDate: null,
    receivedDate: null,
    loadedDate: null,
    deliveredDate: null,
    receivingProcessedDate : null,
    loadingProcessedDate: null,
    deliveryProcessedDate: null,
    earliestAppt: null,
    latestAppt: null,
    originalEarliestAppt: null,
    originalLatestAppt: null,
    receivingUsername: null,
    loadingUsername: null,
    deliveryUsername: null,
    hasDeliverySignatures: false
    } as BarcodeOrderResource;
}


